import { RouteObject } from 'react-router-dom'
import { RoutesEnum } from '../../enums/RoutesEnum'
import { AccompanyingReport } from '../../../pages/Project/subpages/AccompanyingReport/AccompanyingReport'
import { TechnicalReportForm } from '../../../pages/Project/subpages/TechnicalReportForm/TechnicalReportForm'
import { ProjectFormCategoryEnum, ProjectFormEnum } from 'shared'
import { B1Area } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B1Area/B1Area'
import { B2ConstructionDescription } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B2UrbanisticSolution/B2ConstructionDescription'
import { B3TechnicalConnections } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B3BasicTechnicalSolution/B3TechnicalConnections'
import { B4TechnicalInfrastructureConnection } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B4TechnicalInfractructureConnection/B4TechnicalInfrastructureConnection'
import { B5TransportSolution } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B5TransportSolution/B5TransportSolution'
import { B6VegetationAndTerrain } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B6VegetationAndTerrain/B6VegetationAndTerrain'
import { B7EnvironmentalImpacts } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B7EnvironmentalImpacts/B7EnvironmentalImpacts'
import { B8Watermanagement } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B8WaterManagement/B8Watermanagement'
import { B9CivilProtection } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B9CivilProtection/B9CivilProtection'
import { B10ConstructionOrganizationTerms } from '../../../pages/Project/subpages/TechnicalReportForm/projectFormCategory/buildingPermit/B10ConstructionOrganizationTerms/B10ConstructionOrganizationTerms'
import React from 'react'
import { DocumentationSection } from '../../../pages/Project/subpages/DocumentationSection'
import { FolderKeyEnum } from '../../enums/FolderKeyEnum'

export const buildingPermitRoutes: RouteObject[] = [
  // Acc report
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.ACCOMPANYING_REPORT}`,
    element: <AccompanyingReport projectForm={ProjectFormEnum.ACCOMPANYING_REPORT_FORM_A1} />,
  },

  // Technical report
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}`,
    element: <TechnicalReportForm projectFormCategory={ProjectFormCategoryEnum.BUILDING_PERMIT} />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B1}`,
    element: <B1Area />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B2}`,
    element: <B2ConstructionDescription />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B3}`,
    element: <B3TechnicalConnections />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B4}`,
    element: <B4TechnicalInfrastructureConnection />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B5}`,
    element: <B5TransportSolution />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B6}`,
    element: <B6VegetationAndTerrain />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B7}`,
    element: <B7EnvironmentalImpacts />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B8}`,
    element: <B8Watermanagement />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B9}`,
    element: <B9CivilProtection />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.TECHNICAL_REPORT_FORM}/${ProjectFormEnum.TECHNICAL_FORM_B10}`,
    element: <B10ConstructionOrganizationTerms />,
  },

  // Files
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.DOCUMENTATION_SECTION}`,
    element: <DocumentationSection folderKey={FolderKeyEnum.PROJECT_FORM_ATTACHMENTS} />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.OBJECT_DOCUMENTATION}`,
    element: <DocumentationSection folderKey={FolderKeyEnum.OBJECT_DOCUMENTATION} />,
  },
  {
    path: `${RoutesEnum.PROJECTS}/:id/${RoutesEnum.SITUATION_DOCUMENTATION}`,
    element: <DocumentationSection folderKey={FolderKeyEnum.PROJECT_SITUATION_DOCUMENTATION} />,
  },
]
